import { OrdersDataViewContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import CustomApplicationState from "@tKgpco/Store/CustomApplicationState";

import React, { FC, useContext } from "react";
import { connect } from "react-redux";

export interface DiscrepancyHistoryResultCountStyles {
    orderCountText?: TypographyPresentationProps;
}

const mapStateToProps = (state: CustomApplicationState) => {
    return {
        pagination: state.KGPState.DiscrepancyStore.discrepancyCollection?.pagination,
    };
};

export const resultCountStyles: DiscrepancyHistoryResultCountStyles = {};

const styles = resultCountStyles;

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

const DiscrepancyHistoryResultCount: FC<Props> = ({ pagination }) => {
    if (!pagination) {
        return null;
    }

    const { totalItemCount } = pagination;

    if (totalItemCount === 0) {
        return null;
    }

    return (
        <Typography {...styles.orderCountText} data-test-selector="discrepancyHistory_resultCount">
            {totalItemCount} {translate("Discrepancy ticket")}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(DiscrepancyHistoryResultCount),
    definition: {
        group: "Common",
        displayName: " Discrepancy Result Count",
    },
};

export default widgetModule;
